import { render, staticRenderFns } from "./paytrade.vue?vue&type=template&id=6f37ca48&scoped=true&"
import script from "./paytrade.vue?vue&type=script&lang=js&"
export * from "./paytrade.vue?vue&type=script&lang=js&"
import style0 from "./paytrade.vue?vue&type=style&index=0&id=6f37ca48&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f37ca48",
  null
  
)

export default component.exports